import { CreditCardPayableStatus } from '@/features/pay-by-card/types';
import BankAccountDetails from '@/legacy/features/bankAccounts/interfaces';
import { PayeeBusinessType } from '@/legacy/services/company/payee.types';

/**
 * A payee that can be used by multiple companies.
 * @todo Type this better using the backend.
 */
interface UniversalPayee {
  id: string;
}

interface PayeeAccount {
  accountDetails: BankAccountDetails | null;
  accountTransactionType: string;
  additionalVisibleBankFields: Array<string>;
  bank: string;
  bankDetailsRequired: boolean;
  checkAddress: string;
  checkSuite: string;
  checkState: string;
  checkCity: string;
  checkZipCode: string;
  checkPrintNameOnCheckAs: string;
  containsAccountInformation: boolean;
  country: string;
  currency: string;
  deleted: boolean;
  discriminator: string;
  displayName: string;
  emailMoneyTransfer: boolean;
  id: string;
  name: string;
  payeeId: string;
  payee: Payee;
  securityQuestion: string;
  securityAnswer: string;
}

/**
 * The object to send to the API to create a payee in the backend.
 */
interface PayeeBindingModel {
  accounts?: Array<PayeeAccount>;
  accountingSoftwarePayeeId?: string;
  accountingSoftwarePayeeName?: string;
  address?: string;
  businessType?: string;
  city?: string;
  companyId?: string;
  /**
   * The name of the Payee.
   * @required
   */
  contact: string;
  country?: string;
  currency?: string;
  deleted?: boolean;
  displayName?: string;
  /**
   * @required
   */
  email: string;
  id?: string;
  isNetworkPayee?: boolean;
  locale?: string;
  name?: string;
  phone?: string;
  printNameOnCheckAs?: string;
  state?: string;
  suite?: string;
  type?: string;
  padStatus?: string;
  registrationDate?: Date;
  /**
   * @see {@link UniversalPayee}
   */
  universalPayee?: UniversalPayee;
  universalPayeeId?: string;
  vendorAccountNumber?: string;
  zipCode?: string;
}

export enum PayeePadStatus {
  None = 'None',
  Pending = 'Pending',
  Completed = 'Completed',
}

interface Payee {
  accounts: Array<PayeeAccount>;
  accountingSoftwarePayeeId: string;
  accountingSoftwarePayeeName: string;
  address: string;
  businessType: PayeeBusinessType;
  city: string;
  companyId: string;
  contact: string;
  country: string;
  currency: string;
  deleted: boolean;
  displayName: string;
  email: string;
  id: string;
  isNetworkPayee: boolean;
  locale: string;
  name: string;
  phone: string;
  printNameOnCheckAs: string;
  state: string;
  suite: string;
  type: string;
  padStatus: PayeePadStatus;
  registrationDate: Date;
  /**
   * @see {@link UniversalPayee}
   */
  universalPayee: UniversalPayee;
  universalPayeeId: string;
  vendorAccountNumber: string;
  zipCode: string;
  industry: string;
  industrySubCategory: string;
  creditCardPayableStatus: CreditCardPayableStatus;
}

interface PayeesPage {
  items: Array<Payee>;
  totalResults: number;
}

interface PayeesByIdsResponse {
  payees: Array<Payee>;
}

enum SortableFieldTypes {
  Name,
  ContactName,
  Email,
}

export type {
  BankAccountDetails,
  Payee,
  PayeeAccount,
  PayeeBindingModel,
  PayeesPage,
  PayeesByIdsResponse,
};
export { SortableFieldTypes };
